// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"48048962","14":"ac29d48c","61":"177b6554","71":"b1969c59","222":"648f73f6","282":"e4ab476d","341":"1ac6476b","541":"48fb5d64","588":"f2b26028","610":"00aa82ec","636":"f2e691d8","666":"656b4f8a","720":"e77f638e","769":"03320276"}[chunkId] + ".chunk.js";
};